var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#963E97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80005 10.1024L16.0036 8L23.2 10.1024V14.4136C23.2 18.9448 20.3 22.5676 16.0012 24C11.7012 22.568 8.80005 18.944 8.80005 14.4116V10.1024Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 15.6C17.1047 15.6 18.0001 14.7046 18.0001 13.6C18.0001 12.4954 17.1047 11.6 16.0001 11.6C14.8956 11.6 14.0001 12.4954 14.0001 13.6C14.0001 14.7046 14.8956 15.6 16.0001 15.6Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 18.8C19.2 17.9513 18.8629 17.1374 18.2628 16.5373C17.6627 15.9372 16.8487 15.6 16 15.6C15.1514 15.6 14.3374 15.9372 13.7373 16.5373C13.1372 17.1374 12.8 17.9513 12.8 18.8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture);
export default __webpack_public_path__ + "static/media/culture.9d8c0b09c59f4df9b9b7de40a4a5634d.svg";
export { ForwardRef as ReactComponent };